function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 241.8 241.8"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flag_svg__a",
    x1: 120.9,
    x2: 120.9,
    y1: 0.892,
    y2: 242.727,
    gradientTransform: "matrix(1 0 0 -1 0 242.724)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff8619"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fdba17"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.8 120.9c0 29.8-10.9 58.5-30.8 80.6-.1.1-.2.3-.4.4s-.4.4-.5.6c-45 49.3-121.5 52.7-170.7 7.7-2.7-2.5-5.3-5-7.7-7.7l-.4-.5-.4-.5C-13.7 151.8-9.5 75.4 40.2 30.8S166.4-9.5 211 40.3c19.8 22.1 30.8 50.9 30.8 80.6",
    style: {
      fill: "url(#flag_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9 163.1c-8.3 0-16.5.8-24.6 2.5l-8.1-53.7c14.1 2.8 53.3 9.7 47-2.9-4.1-8.1 34.2.1 45.7 4l-7.7-61.6c-18.5-4.2-60.6-6.7-53.9 1.6 10.3 12.8-43.5 6-43.5 6L89 167.4c-22 6-41.9 18.2-57.3 35.1 45 49.3 121.5 52.7 170.7 7.7 2.7-2.5 5.3-5 7.7-7.7-22.8-25.1-55.2-39.4-89.2-39.4",
    style: {
      fill: "#111"
    }
  }));
};
export default SvgFlag;